<template>
  <div class="fu">
    <van-skeleton :row="25" :loading="ske">
      <mt-header fixed title="通知">
  
      </mt-header>

      <template>
        <img src="../../assets/images/fu2.png" alt="" />
        <p>店铺已关闭</p>
      </template>
    </van-skeleton>
  </div>
</template>
<script>
export default {
  data() {
    return {
      name: "",
      ske: true,
    };
  },
  created() {},
  mounted() {
    this.ske = false;
  },
  methods: {
    wanchen() {
      this.$router.push({ name: "MyOrder", query: { index: "2" } });
    },
    back() {
      this.$router.push({ name: "MyOrder", query: { index: "1" } });
    },
    backHome() {
      this.$router.push({ name: "MyOrder", query: { index: "1" } });
    },
  },
};
</script>
<style  lang="scss" scoped>
.fu {
  > img {
    width: 1.5rem;
    margin: 0px auto;
    margin-top: 1rem;
  }
  p:nth-of-type(1) {
    font-size: 0.24rem;
    color: rgb(51, 51, 51);
    text-align: center;
    margin-top: 0.3rem;
  }
  p:nth-of-type(2) {
    font-size: 0.15rem;
    color: rgb(157, 164, 181);
    text-align: center;
    margin: 0.1rem 0px;
  }
  > .mint-button--default {
    border-radius: 0.2rem;
    background: rgb(236, 193, 96);
    padding: 0.01rem 0.45rem !important;
    margin: 0px auto;
    font-size: 0.15rem;
    height: 0.35rem !important;
    color: white;
    display: block;
    margin-top: 0.48rem;
  }
}
</style>